import { Box } from '@amzn/awsui-components-react-v3';
import React, { ReactElement } from 'react';

export interface EmptyStateProps {
	title: string;
	subtitle: string;
	action?: ReactElement;
}
export default function EmptyState({
	title,
	subtitle,
	action,
}: EmptyStateProps) {
	return (
		<Box textAlign="center" color="inherit">
			<Box variant="strong" textAlign="center" color="inherit">
				{title}
			</Box>
			<Box variant="p" padding={{ bottom: 's' }} color="inherit">
				{subtitle}
			</Box>
			{action ?? ''}
		</Box>
	);
}
